var map = {
	"./apple.png": 26288,
	"./apple2.png": 42487,
	"./bg.png": 23895,
	"./down.png": 12084,
	"./down2.png": 31193,
	"./map.png": 28115,
	"./pl1.png": 38352,
	"./pl2.png": 87732,
	"./s1.png": 35169,
	"./s2.png": 29572,
	"./s3.png": 23544,
	"./v1.png": 3064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44140;